module.exports = __webpack_public_path__ + "assets/img/sta.44938aca.png";